"use client";

import { useCallback } from "react";
import { clientApi } from "@frontend/lib/api";
import { usePollRefresh } from "@frontend/lib/use-poll-refresh";

/** Polls for sidebar / status / payment changes and reloads only this room. */
export function CollabRoomSync({
  collabId,
  revision,
  onChange,
}: {
  collabId: string;
  revision: string;
  onChange: () => void;
}) {
  const fetchRevision = useCallback(async () => {
    const data = await clientApi<{ revision: string }>(`/api/collabs/${collabId}/sync`);
    return data.revision;
  }, [collabId]);

  usePollRefresh(revision, fetchRevision, { onChange });
  return null;
}
